export default __webpack_public_path__ + "static/media/no-image-spo.60ca4285.jpg";